import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/right_l.png';

const _withScopeId = n => (_pushScopeId("data-v-6612d41a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "more-btn"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  key: 0,
  class: "course-list-container"
};
const _hoisted_7 = {
  class: "course-content"
};
const _hoisted_8 = {
  class: "course-name"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "course-line"
}, null, -1));

const _hoisted_10 = {
  class: "course-other"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "teacher-name"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1));

const _hoisted_14 = {
  class: "course-org"
};
const _hoisted_15 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonTitle = _resolveComponent("CommonTitle");

  const _component_SwiperSlide = _resolveComponent("SwiperSlide");

  const _component_Swiper = _resolveComponent("Swiper");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CommonTitle, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.menu && $props.menu.module_name || 'SPOC'), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleMore && $options.handleMore(...args))
  }, _hoisted_5)]), $data.homeCourseList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [$data.homeCourseList.length ? (_openBlock(), _createBlock(_component_Swiper, {
    key: 0,
    navigation: true,
    modules: $data.modules,
    slidesPerView: 3.5,
    spaceBetween: 20,
    centeredSlides: true,
    watchSlidesProgress: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    class: "course-list"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.homeCourseList, item => {
      return _openBlock(), _createBlock(_component_SwiperSlide, {
        key: item.id,
        onClick: $event => $options.goDetail(item)
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "course-card",
          style: _normalizeStyle({
            'background-image': `url(${item.course_cover_url})`
          })
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.course_name), 1), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
          src: item.avatar || require('@/assets/images/user_avatar.jpg'),
          class: "course-teacher",
          alt: ""
        }, null, 8, _hoisted_11), _createElementVNode("span", _hoisted_12, _toDisplayString(item.lecturer), 1), _hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(item.organ_name), 1)])])], 4)]),
        _: 2
      }, 1032, ["onClick"]);
    }), 128))]),
    _: 1
  }, 8, ["modules", "slidesPerView"])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_Empty)]))]);
}